export const getEventTypeEventsForEntity = (eventType, entityId, events) => {
  return events.filter(
    (event) => event.class === "sport" && event.entityId === entityId && eventType === event.eventType,
  );
}

export const shouldCountFouls = (event, sport, fixtureProfile, currentState) => {
  const foulEventSubtypesToSkip = ["drawn", "benchTechnical", "coachDisqualifying", "coachTechnical"];
  const isFoulEvent =
    event.eventType === "foul" &&
    event.status !== "deleted" &&
    !foulEventSubtypesToSkip.includes(event.subType);

  if (!isFoulEvent) {
    return false;
  }

  const currentPeriod = currentState?.period?.periodId || 0;
  const mostRecentPeriodToResetFouls = [...fixtureProfile.resetFoulsAfterPeriods]
    .sort((a, b) => a - b) // because sometimes backend returns this table in different order
    .filter((p) => p < currentPeriod)
    .at(-1) ?? -1;

  if (event.periodId <= mostRecentPeriodToResetFouls) {
    return false;
  }

  if (sport === "basketball") {
    // Include all overtime periods
    if (event.periodId > fixtureProfile.numberOfPeriods) {
      return true;
    }

    // Include last regular period, but EXCLUDE if game is in pendingExtra status
    if (currentPeriod === fixtureProfile.numberOfPeriods && currentState?.period?.periodStatus === "pendingExtra") {
      return false;
    }
  }

  return true;
};
